import React from "react";
import { gql } from "@apollo/client";
import { client } from "helper/apolloConfig";
import * as Sentry from "@sentry/react";
import { Button } from "../../shared/Components/button";

const DEBUG_SENTRY_QUERY = gql`
  query DebugSentry {
    debugSentry
  }
`;

const SentryTest = () => {
  const testFrontendError = () => {
    console.log("🚨 Triggering Frontend Sentry Test Error...");
    Sentry.captureException(new Error("Frontend Sentry Test Error! 🎯"), {
      tags: {
        testType: "manual",
        source: "frontend",
      },
      level: "error",
    });
    alert("Frontend error sent to Sentry! Check your Sentry dashboard.");
  };

  const testBackendError = async () => {
    console.log("🚨 Triggering Backend Sentry Test Error...");
    try {
      await client.query({
        query: DEBUG_SENTRY_QUERY,
        fetchPolicy: "network-only",
      });
    } catch (error) {
      console.log("Backend error triggered (this is expected):", error);
      alert("Backend error sent to Sentry! Check your Sentry dashboard.");
    }
  };

  return (
    <div style={{ 
      padding: "40px", 
      maxWidth: "600px", 
      margin: "0 auto",
      fontFamily: "Arial, sans-serif"
    }}>
      <h1 style={{ color: "#333", marginBottom: "20px" }}>🔧 Sentry Test Page</h1>
      <p style={{ color: "#666", marginBottom: "30px" }}>
        Use the buttons below to test Sentry error tracking for both frontend and backend.
      </p>
      
      <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
        <Button
          onClick={testFrontendError}
          style={{
            padding: "15px 30px",
            fontSize: "16px",
            backgroundColor: "#7C3AED",
            color: "white",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
          }}
        >
          🎯 Test Frontend Sentry Error
        </Button>

        <Button
          onClick={testBackendError}
          style={{
            padding: "15px 30px",
            fontSize: "16px",
            backgroundColor: "#DC2626",
            color: "white",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
          }}
        >
          🚨 Test Backend Sentry Error
        </Button>
      </div>

      <div style={{ 
        marginTop: "30px", 
        padding: "20px", 
        backgroundColor: "#F3F4F6", 
        borderRadius: "8px" 
      }}>
        <h3 style={{ color: "#333", marginBottom: "10px" }}>📝 Instructions:</h3>
        <ol style={{ color: "#666", lineHeight: "1.8" }}>
          <li>Click either button to trigger a test error</li>
          <li>Check your browser console for confirmation</li>
          <li>Go to your Sentry dashboard to see the error</li>
          <li>Frontend errors will show as "Frontend Sentry Test Error! 🎯"</li>
          <li>Backend errors will show as "My first Sentry error! 🚨"</li>
        </ol>
      </div>
    </div>
  );
};

export default SentryTest;

